import { render } from "./pactosSiniestros.vue?vue&type=template&id=50414e10"
import script from "./pactosSiniestros.vue?vue&type=script&lang=js"
export * from "./pactosSiniestros.vue?vue&type=script&lang=js"

import "./pactosSiniestros.vue?vue&type=style&index=0&id=50414e10&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__